import { graphql } from "@cappelendamm/crystallize-types/pim/gql";
export const getSkuPriceLists = async (sku, { client }) => {
    const response = await client.pim.request(graphql(`
      query GetSkuPriceLists($sku: String!, $tenantId: ID!) {
        product {
          getVariant(sku: $sku, language: "no-nb", tenantId: $tenantId) {
            priceVariants {
              priceLists(status: active) {
                startDate
                endDate
                identifier
                modifier
                modifierType
                price
              }
            }
            price
          }
        }
      }
    `), { sku, tenantId: client.tenantId });
    return response.product.getVariant;
};
